// extracted by mini-css-extract-plugin
module.exports = {"links":"DownloadBonusFbContainer__links--GzqRY","disabled":"DownloadBonusFbContainer__disabled--3zXAZ"};